import { render, staticRenderFns } from "./TutorViewUserPermissionsCard.vue?vue&type=template&id=2d4ebba5&"
import script from "./TutorViewUserPermissionsCard.vue?vue&type=script&lang=js&"
export * from "./TutorViewUserPermissionsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports